import React, { useState, useEffect } from "react";
import Preloader from "./Components/Pre/Pre";
import Navbar from "./Components/Header/Header";
//import Home from "./components/Home/Home";
//import About from "./components/About/About";
//import Projects from "./components/Projects/Projects";
//import Footer from "./components/Footer";
import { HashRouter, Route, Routes } from "react-router-dom";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Profile from "./Components/Profile/Profile";
import Rules from "./Components/Rules/Rules";
import Interests from "./Components/Interests/Interests";
import Fanworks from "./Components/Fanworks/Fanworks";
import Contacts from "./Components/Contact/Contacts";
import Footer from "./Components/Footer"

//import ScrollToTop from "./components/ScrollToTop";
//import AssetDrives from "./components/AssetDrives/AssetDrives";

function App() {
  const [load, updateLoad] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 3500);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <HashRouter basename="/">      
    <Preloader load={load} />
      <div className="App main">
       <Navbar />
       {/*  <ScrollToTop />*/}
        <Routes>
        <Route path='/' element={<Profile/>} />
        <Route path='/rules' element={<Rules/>} />
        <Route path='/interests' element={<Interests/>} />
        <Route path='/fanworks' element={<Fanworks/>} />
        <Route path='/contact' element={<Contacts/>} />
        </Routes>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;
